import React, { useState, useRef } from "react";
import "./User_Reviews.css";
import Common_title from "../../common/common-title/Common_title";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

const testimonials = [
    {
        name: "Reena M.",
        role: "App User",
        image: "/assets/images/home/user-review/img_1.png",
        text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer nec odio. Praesent libero. Sed cursus ante dapibus diam.",
    },
    {
        name: "Teera V.",
        role: "Vendor",
        image: "/assets/images/home/user-review/img_2.png",
        text: "Praesent mauris. Fusce nec tellus sed augue semper porta. Mauris massa. Vestibulum lacinia arcu eget nulla.",
    },
    {
        name: "Sara K.",
        role: "App User",
        image: "/assets/images/home/user-review/img_3.png",
        text: "Sed nisi. Nulla quis sem at nibh elementum imperdiet. Duis sagittis ipsum. Praesent mauris.",
    },
    {
        name: "Mike S.",
        role: "App User",
        image: "/assets/images/home/user-review/img_4.png",
        text: "Vestibulum lacinia arcu eget nulla. Class aptent taciti sociosqu ad litora torquent per conubia nostra.",
    },
    {
        name: "Nina P.",
        role: "App User",
        image: "/assets/images/home/user-review/img_5.png",
        text: "Sed cursus ante dapibus diam. Sed nisi. Nulla quis sem at nibh elementum imperdiet.",
    },
    {
        name: "Reena M.",
        role: "App User",
        image: "/assets/images/home/user-review/img_6.png",
        text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer nec odio. Praesent libero.",
    },
    {
        name: "Teera V.",
        role: "Vendor",
        image: "/assets/images/home/user-review/img_7.png",
        text: "Praesent libero. Sed cursus ante dapibus diam. Sed nisi. Nulla quis sem at nibh elementum imperdiet.",
    },
];

function User_Reviews() {
    const [current, setCurrent] = useState(0);
    const swiperRef = useRef(null);
    const prevRef = useRef(null);
    const nextRef = useRef(null);

    return (
        <section className="User_Reviews margin_section">
            <div className="container">
                <Common_title title="CAMPUS DEAL " subtitle="User Reviews" />

                <div className="wave-container">
                    <div className="avatar-swiper-wrapper">
                        <Swiper
                            modules={[Navigation]}
                            slidesPerView={5}
                            centeredSlides
                            spaceBetween={50}
                            loop
                            onBeforeInit={(swiper) => {
                                swiper.params.navigation.prevEl = prevRef.current;
                                swiper.params.navigation.nextEl = nextRef.current;
                            }}
                            onSwiper={(swiper) => {
                                swiperRef.current = swiper;
                            }}
                            onSlideChange={(swiper) => {
                                setCurrent(swiper.realIndex);
                            }}
                            navigation={{
                                prevEl: prevRef.current,
                                nextEl: nextRef.current,
                            }}
                            breakpoints={{
                                0: { slidesPerView: 2.5 },
                                485: { slidesPerView: 3.5 },
                                575: { slidesPerView: 5 },
                                768: { slidesPerView: 5 },
                            }}
                            className="avatar-swiper"
                        >
                            {testimonials.map((item, index) => (
                                <SwiperSlide key={index}>
                                    <div className="img_holder">
                                        <img
                                            src={item.image}
                                            alt={item.name}
                                            className={`testimonial-avatar ${index === current ? "active" : ""}`}
                                            onClick={() => swiperRef.current?.slideToLoop(index)}
                                        />
                                    </div>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>
                </div>

                {/* Testimonial text content */}
                <div className="testimonial-content">
                    <div className="testimonial-box">
                        <h3>{testimonials[current].name}</h3>
                        <p className="role">{testimonials[current].role}</p>
                        <p className="description">{testimonials[current].text}</p>
                    </div>
                    {/* Custom Navigation Buttons */}
                    <div className="navigation_btn_holder">
                        <div ref={prevRef} className="swiper-button-prev"></div>
                        <div ref={nextRef} className="swiper-button-next"></div>
                    </div>
                </div>

            </div>
        </section>
    );
}

export default User_Reviews;
